import React, { useState } from "react"; 
import { Formik } from "formik";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { API } from 'aws-amplify';
import { useToasts } from 'react-toast-notifications';
import UploadFile from '../../../components/UploadFile';
import ResizeImg from '../../../components/ResizeImg';

const DeviceDocs = (props) => {
    const {
        asset,
        setAsset
     } = props

    const { addToast } = useToasts();
    // const [isLoading, setIsLoading] = useState(false);
    const [img, setImg] = useState(asset.img || null);
    const [file, setFile] = useState();

    const handleUploadImg = async (id) => {

        // upload file
        if(file) {
            const imgPath = await UploadFile('img', '/', file, asset.id);

            const data = { ...asset, img:imgPath }

            API.post('asset', '/', {
                body: data,
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            })
            .then(res => {
                console.log(res);
                setAsset({ ...asset, img: imgPath });
                setImg(imgPath)
                setFile();
                addToast('Photo Saved', { appearance: 'success' });
            }).catch(error => {
                console.log(error)
                addToast('Error Saving Photo', { appearance: 'error' });
            });
        }

    };

    const handleRemoveImg = async (id) => {

        const data = { ...asset, img:null }
        // upload file
        API.post('asset', '/', {
            body: data,
            headers: {
                'x-api-key': process.env.REACT_APP_API_KEY,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        })
        .then(res => {
            // console.log(res);
            setAsset({ ...asset, img: null });
            setImg()
            setFile();
            addToast('Photo Deleted', { appearance: 'success' });
        }).catch(error => {
            console.log(error)
            addToast('Error Deleting Photo', { appearance: 'error' });
        });

    };

    const handleChangeFile = async (event) => {
        try {
            const file = event.target.files[0];
            const image = await ResizeImg(file);
            // console.log(image)
            setFile(image);
          } catch (err) {
            console.log(err);
          }
      }

return (
<div className="col-md-12">
    <Formik
    initialValues={asset}
    // validationSchema={schema}
    onSubmit={ (values, { setSubmitting }) => {
        // handleSubmit(values);
        setSubmitting(false);
    }}
    >
    {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
    <div className="row">
            <div className="col-md-4">
                <h4>Sensor configuration</h4>
                <div className='pt-4'>
                    <Form.Group controlId="file">
                        <Form.Control
                            as="input"
                            value={values.file}
                            onChange={handleChangeFile}  // {e => {setFile(e.target.files[0])}}
                            accept="image/*"
                            type="file" />
                    </Form.Group>
                    <div className='row'>
                        <div className='p-1'>
                            <Button className='mt-2' variant="primary" size="sm" onClick={()=>{handleUploadImg(asset.id)}}>
                            Upload Photo
                            </Button>
                        </div>
                        <div className='p-1'>
                            <Button className='mt-2' variant="danger" size="sm" onClick={()=>{handleRemoveImg(asset.id)}}>
                            Remove Photo
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-8">
                {(img)?
                <img
                    src={img}
                    // src={asset.img}
                    className="d-inline-block align-top rounded"
                    alt="Sensor Diagram"
                    width="100%"
                />
                :''}
            </div>
    </div>
        )}
        </Formik>
</div>
)}

export default DeviceDocs;